import { WhatsApp, ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import {
  ServicePageWrapper,
  ServiceHeader,
  ServiceTitle,
  ServiceDescription,
  ServiceContent,
  ServiceSection,
  SectionTitle,
  SectionText,
  BenefitsList,
  BenefitItem,
  CTASection,
  CTAButton,
  CTAText,
  FAQSection,
  FAQTitle,
  FAQList,
  FAQItem,
  FAQQuestion,
  FAQAnswer
} from './styles';

const ServiceTemplate = ({ 
  title,
  description,
  sections,
  benefits,
  faqs,
  whatsappMessage
}) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(whatsappMessage);
    window.open(`https://wa.me/972548827511?text=${message}`);
  };

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <ServicePageWrapper>
      <ServiceHeader>
        <ServiceTitle>{title}</ServiceTitle>
        <ServiceDescription>{description}</ServiceDescription>
      </ServiceHeader>

      <ServiceContent>
        {sections.map((section, index) => (
          <ServiceSection key={index}>
            <SectionTitle>{section.title}</SectionTitle>
            <SectionText>{section.content}</SectionText>
          </ServiceSection>
        ))}

        <BenefitsList>
          {benefits.map((benefit, index) => (
            <BenefitItem key={index}>
              {benefit}
            </BenefitItem>
          ))}
        </BenefitsList>

        <FAQSection>
          <FAQTitle>שאלות נפוצות</FAQTitle>
          <FAQList>
            {faqs.map((faq, index) => (
              <FAQItem key={index} onClick={() => toggleFAQ(index)}>
                <FAQQuestion isOpen={openFAQ === index}>
                  {faq.question}
                  <ExpandMore style={{ transform: openFAQ === index ? 'rotate(180deg)' : 'none' }} />
                </FAQQuestion>
                <FAQAnswer isOpen={openFAQ === index}>
                  {faq.answer}
                </FAQAnswer>
              </FAQItem>
            ))}
          </FAQList>
        </FAQSection>

        <CTASection>
          <CTAText>רוצים לשמוע עוד על השירות?</CTAText>
          <CTAButton onClick={handleWhatsAppClick}>
            <WhatsApp />
            שלחו הודעה לייעוץ ראשוני
          </CTAButton>
        </CTASection>
      </ServiceContent>
    </ServicePageWrapper>
  );
};

export default ServiceTemplate; 